module.exports = __webpack_public_path__ + "static/media/select_package.043f9908.png";